import {connect} from "react-redux";
import {Box, Tab} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import {SyntheticEvent, useState} from "react";
import {TabContext, TabList, TabPanel} from "@mui/lab";
import {AWSContent} from "./content/AWSContent";
import AssetExplorer from "./AssetExplorer";
import {FrameIOContent} from "./content/FrameIOContent";
import {VideoDashboard} from "./VideoDashboard";

const useScriptStyles = makeStyles(theme => ({
    tabs: {
        display: 'flex',
        flexDirection: "column",
        flexGrow: 1,
        height: "100%"
    },
    tabPanels: {
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        height: "calc(100% - 48px)"
    },
    tabPanel: {
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        height: "100%",
        padding: 0
    }
}));

interface IVideoAssets {
    awsContent: AWSContent
    awsRoot?: string
    frameIOContent: FrameIOContent
    frameIORoot?: string
}
function VideoAssets({awsContent, awsRoot, frameIOContent, frameIORoot}: IVideoAssets) {
    const classes = useScriptStyles();
    const [selected, setSelected] = useState<string>();
    const [tab, setTab] = useState("dashboard");
    const handleTabChange = (event: SyntheticEvent, value: any) => setTab(value);
    const handleAssetClick = (source: string, key: string, format?: string) => {
        setTab(source);
        if (source === "frameIo" && frameIOContent) {
            setSelected(frameIOContent.getBlockNameKey(key));
        } else if (source === "aws" && awsContent) {
            setSelected(awsContent.getBlockNameKey(key, format));
        }
    };

    return (
        <TabContext value={tab}>
            <Box className={classes.tabs}>
                <TabList onChange={handleTabChange}>
                    <Tab label="Dashboard" value="dashboard"/>
                    <Tab label="Frame.io" value="frameIo"/>
                    <Tab label="AWS" value="aws"/>
                </TabList>
                <Box className={classes.tabPanels}>
                    {tab === "dashboard" &&
                        <TabPanel className={classes.tabPanel} value="dashboard">
                            <VideoDashboard aws={awsContent} frameIO={frameIOContent} onClick={handleAssetClick}/>
                        </TabPanel>}
                    {tab === "frameIo" && frameIOContent &&
                        <TabPanel className={classes.tabPanel} value="frameIo">
                            <AssetExplorer content={frameIOContent} root={frameIORoot} selected={selected}/>
                        </TabPanel>}
                    {tab === "aws" && awsContent &&
                        <TabPanel className={classes.tabPanel} value="aws">
                            <AssetExplorer content={awsContent} root={awsRoot} selected={selected}/>
                        </TabPanel>}
                </Box>
            </Box>
        </TabContext>
    );
}
const mapStateToProps = (store: never) => ({
});
const connected = connect(mapStateToProps, {
})(VideoAssets);

export {connected as VideoAssets};
